module.exports = __webpack_public_path__ + "static/media/laleh.017bde80.jpg";